export function isRunningInApp() {
  return window.Logout !== undefined;
}

// ezt nem tudjuk desktop-on megnyitni, ezert clipboardba masoljuk
// mobilon megnyithato
export function isTelSchema(ref: string) {
  return ref.startsWith('tel:');
}

function isModernIPad() {
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  return navigator.userAgent.includes('Macintosh') && isTouch;
}

function isPhoneScreen() {
  return window.outerWidth < 768 || /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || isModernIPad();
}

// EZT HASZNÁLD!!
export function isPhoneOrHighScreen() {
  return isPhoneScreen() || window.outerHeight > window.outerWidth;
}

export function isAppleDevice() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent) || isModernIPad();
}
